import React from "react"
import PropTypes from "prop-types"
import { Row } from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
import { CustomSelect, CustomAvField } from "components/Common/Input"
import { parameterCode } from "constant/utility"

const FilterForm = ({ model, t }) => {
  return (
    <>
      <Row>
        <div className="mb-3">
          <CustomAvField
            label={t("Address Search")}
            name="search"
            type="text"
            className="form-input"
            placeholder={t("Address Search")}
            value={model.search}
          />
        </div>
      </Row>
      <Row>
        <div className="mb-3">
          <CustomSelect
            label={t("Address Type")}
            portal
            name="type"
            value={model.type}
            code={parameterCode.ADDRESS_TYPE}
          />
        </div>
      </Row>
    </>
  )
}

FilterForm.propTypes = {
  model: PropTypes.object,
  t: PropTypes.any,
}

export default withTranslation(["partyPage", "common"])(FilterForm)
